import styled from "styled-components";

export const StyledTextOverflow = styled.div`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
`;
